import React, {useEffect, useState} from "react";
import {useGetCurrentUser, useGetUsersSessions} from "api/api-hooks/user-hooks";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import {easasAlert} from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import UserStatisticsDatatable
    from "./components/user-statistics-datatable/UserStatisticsDatatable";

import UserStatisticsGanttChart
    from "./components/users-statistics-gantt-chart/UsersStatisticsGanttChart";
import {Dropdown} from "primereact/dropdown";
import {addToDate} from "utils/time-utils";


function generateCompanyListOptions(userSessionData: any[]) {
    const companyList = new Set();
    userSessionData.forEach((user: any) => {
        companyList.add(user.companyRef);
    });
    return Array.from(companyList).map((company) => {
        return {label: company, value: company};
    });
}

function generateJobTitleOptions(userSessionData: any[]) {

    const titlesList = new Set();
    userSessionData.forEach((user: any) => {
        titlesList.add(user.jobTitle)
    })

    return Array.from(titlesList).map(title => {
        if(title === undefined) {
            return {label: "No title", value: "noTitle"}
        }
      return {label: title, value: title}
    })
}

export function secondsToHm(d: number) {
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);

    const hDisplay = h > 0 ? h + "h " : "";
    const mDisplay = m > 0 ? m + "m " : "";

    return hDisplay + mDisplay;
}

const groupOptions = [
    {label: "User", value: "username"},
    {label: "Job Title", value: "jobTitle"},
];

const UsersStatisticsDashboard = () => {
    const [dateFrom, setDateFrom] = useState<Date>(addToDate(new Date(), -7, "DAYS"));
    const [dateTo, setDateTo] = useState<Date>(new Date());


    const [userSessionData, setUserSessionData] = useState<any[]>([]);
    const [currentUser, setCurrentUser] = useState(null)
    const [groupingType, setGroupingType] = useState<string>("username");
    const [companyFilter, setCompanyFilter] = useState<string>();
    const [jobTitleFilter, setJobTitleFilter] = useState<string>()
    const [companyListOptions, setCompanyListOptions] = useState([]);
    const [jobTitleOptions, setJobTitleOptions] = useState([])


    const queryData = useGetUsersSessions(dateFrom.toISOString(), dateTo.toISOString(), companyFilter, jobTitleFilter,{
        refetchInterval: 10000,
        onSuccess: (data) => {
            setUserSessionData(data);
            setCompanyListOptions(generateCompanyListOptions(data));
            setJobTitleOptions(generateJobTitleOptions(data))
        },
        onError: (error) => {
            easasAlert("error", `${error.data}`, "error");
        }
    });

    useGetCurrentUser({
        onSuccess:(data) => {
            setCurrentUser(data)
        },
        onError: () => {
            easasAlert("Error", "Failed to get current user", "error")
        }
    });

    useEffect(() => {
        queryData.refetch()
    }, [companyFilter, jobTitleFilter])

    return (
        <div>
            <div className="flex justify-content-between align-items-center">
                <div className="flex gap-2 mb-2">
                    <div className="flex flex-column gap-2">
                        <label>Date from:</label>
                        <CalendarWrapper value={dateFrom} onChange={e => setDateFrom(e)}/>
                    </div>
                    <div className="flex flex-column gap-2">
                        <label>Date to:</label>
                        <CalendarWrapper value={dateTo} onChange={e => setDateTo(e)}/>
                    </div>
                </div>
                <div className="flex gap-2 ">
                    {currentUser && currentUser.effectivePermissions.includes("ADMIN") && <div className="flex flex-column gap-2">
                        <label>Company: </label>
                        <Dropdown
                            value={companyFilter}
                            placeholder="Select a Company"
                            options={companyListOptions}
                            onChange={e => setCompanyFilter(e.value)}
                            showClear
                        />
                    </div>}
                    <div className="flex flex-column gap-2">
                        <label>Group By: </label>
                        <Dropdown
                            value={groupingType}
                            options={groupOptions}
                            onChange={e => setGroupingType(e.value)}
                        />
                    </div>
                    { groupingType === "jobTitle" && <div className="flex flex-column gap-2">
                        <label>Job Title</label>
                        <Dropdown
                            placeholder="Select Job"
                            value={jobTitleFilter}
                            options={jobTitleOptions}
                            onChange={e => setJobTitleFilter(e.value)}
                            showClear
                        />
                    </div>}
                </div>
            </div>
            <UserStatisticsGanttChart userSessionData={userSessionData} groupingType={groupingType} companyFilter={companyFilter} jobTitleFilter={jobTitleFilter}/>
            <UserStatisticsDatatable userSessionData={userSessionData} groupingType={groupingType} companyFilter={companyFilter}/>
        </div>
    );
};

export default UsersStatisticsDashboard;